<template>
  <div
    ref="picker"
    class="wt-area-picker-stage shape-point"
    :class="classObj"
    :style="styleObj"
    :tabindex="index"
    @mousedown="onMouseDown"
    @keydown="move"
  >
    <div class="shape">+</div>
  </div>
</template>

<script>
/**
 *  Asset Editor's OverlaysFieldContent
 */
import app from 'app';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  props: ['point', 'index'],

  data() {
    return {
      pointWidth: 21,
      offsetX: this.point.offsetX,
      offsetY: this.point.offsetY,
    };
  },

  computed: {
    ...mapGetters('assetEditor', ['pageTmpState', 'currentPage']),

    classObj() {
      return {
        active: this.activeOverlay === this.point.name,
        hover: this.pageTmpState.hoveredField === this.point.name,
      };
    },

    activeOverlay() {
      return this.pageTmpState.activeOverlay;
    },

    leftPx() {
      return Math.round(this.offsetX * app.ASSET_EDITOR_WIDTH);
    },

    topPx() {
      return Math.round(this.offsetY * app.ASSET_EDITOR_HEIGHT);
    },

    styleObj() {
      const offset = Math.floor(this.pointWidth / 2);
      return {
        left: this.leftPx - offset + 'px',
        top: this.topPx - offset + 'px',
        width: this.pointWidth + 'px',
        height: this.pointWidth + 'px',
        zIndex: this.zIndex,
      };
    },
  },

  mounted() {
    this.initDraggable();

    if (_.isEmpty(this.point.value)) {
      const valueChanges = {
        id: this.currentPage.id,
        name: this.point.name,
        type: this.point.type,
        value: this.point.defaultValue,
      };
      this.updateField(valueChanges, false);
    }
    // this.$refs.picker.addEventListener('keydown', this.move);
  },

  watch: {
    activeOverlay: function (value) {
      const maxZ = +this.maxZ;

      if (value !== this.point.name) {
        return;
      }

      this.$refs.picker.focus();
      const newZIndex = maxZ + 1;

      const valueChanges = {
        name: this.point.name,
        type: this.point.type,
        value: `${this.offsetX} ${this.offsetY}`,
      };
      this.updateField(valueChanges);
      this.zIndex = newZIndex;
    },
  },

  methods: {
    ...mapMutations('assetEditor', ['setTmpPageState']),
    ...mapActions('assetEditor', ['ADD_OR_UPDATE_CUSTOM_OVERLAY_FIELD']),

    initDraggable() {
      const containment = this.$el.closest('.wt-asset-editor-middle-custom');
      $(this.$refs.picker).draggable({
        snap: '.wt-asset-editor-stage',
        snapTolerance: 7,
        scroll: false,
        containment,
        snapMode: 'inner',
        stop: (event, ui) => {
          this.updateDimensions(ui);
        },
      });
    },

    onMouseDown() {
      this.setTmpPageState({
        activeOverlay: this.point.name,
      });
    },

    updateDimensions(ui) {
      const offset = Math.floor(this.pointWidth / 2);
      ui.position.left += offset;
      ui.position.top += offset;
      const x = app.sfp(ui.position.left / app.ASSET_EDITOR_WIDTH);
      const y = app.sfp(ui.position.top / app.ASSET_EDITOR_HEIGHT);
      const value = `${x} ${y}`;
      const valueChanges = {
        name: this.point.name,
        type: this.point.type,
        value,
      };
      this.offsetX = x;
      this.offsetY = y;
      this.updateField(valueChanges);
    },

    move(e) {
      const arrowCodes = _.pick($.ui.keyCode, ['UP', 'DOWN', 'LEFT', 'RIGHT']);
      let x = this.leftPx;
      let y = this.topPx;

      if (
        e.target !== e.currentTarget ||
        !_.values(arrowCodes).includes(e.which)
      ) {
        return;
      }
      switch (e.which) {
        case arrowCodes.UP:
          y = y - 1;
          break;
        case arrowCodes.DOWN:
          y = y + 1;
          break;
        case arrowCodes.LEFT:
          x = x - 1;
          break;
        case arrowCodes.RIGHT:
          x = x + 1;
          break;
      }

      x = app.sfp(x / app.ASSET_EDITOR_WIDTH);
      y = app.sfp(y / app.ASSET_EDITOR_HEIGHT);
      this.offsetX = x;
      this.offsetY = y;

      const value = `${x} ${y}`;
      const valueChanges = {
        name: this.point.name,
        type: this.point.type,
        value,
      };
      this.updateField(valueChanges);
    },

    updateField(valueChanges, makeDirty = true) {
      this.ADD_OR_UPDATE_CUSTOM_OVERLAY_FIELD(valueChanges);
      if (makeDirty) {
        this.setTmpPageState({
          userInteractedWithPage: true,
        });
      }
    },
  },
};
</script>
